import { Link } from "react-router-dom";
import { articles, latestList } from "../../../mocks/news";

const lead = articles.find((a) => a.slug === "honghu-dongzuopian-tuxin") ?? latestList[0];
const sideList = latestList.filter((a) => a.slug !== lead.slug).slice(0, 4);

export default function Hero() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-10 md:px-6">
      {/* 编辑头条提示 */}
      <div className="flex items-center gap-2 pt-6 text-sm">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-primary-700">
          <i className="ri-fire-fill" /> 编辑精选
        </span>
        <span className="hidden text-foreground-500 sm:inline">每天精选最值得一看的娱乐圈与网红圈资讯</span>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* 头条大图 */}
        <Link
          to={`/news/${lead.slug}`}
          className="group relative block overflow-hidden rounded-xl lg:col-span-2"
        >
          <img
            src={lead.cover}
            alt={lead.title}
            title={lead.title}
            className="h-[300px] w-full object-cover transition-transform duration-700 group-hover:scale-105 md:h-[420px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
          <span className="absolute left-4 top-4 inline-flex items-center gap-1 whitespace-nowrap rounded-sm bg-accent-400 px-2.5 py-1 text-xs font-bold text-secondary-900">
            <i className="ri-flashlight-fill" /> 本日头条
          </span>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
            <p className="flex items-center gap-3 text-xs text-background-100/80">
              <span>{lead.categoryName}</span>
              <span className="opacity-50">·</span>
              <span>{lead.author}</span>
              <span className="opacity-50">·</span>
              <span>{lead.date}</span>
            </p>
            <h2 className="mt-2 font-serif text-2xl font-black leading-snug text-background-50 md:text-4xl">
              {lead.title}
            </h2>
            <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-background-100/90 md:line-clamp-2">
              {lead.summary}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 rounded-md bg-background-50/95 px-3 py-1.5 text-sm font-medium text-foreground-900 transition-colors group-hover:bg-accent-400 group-hover:text-secondary-900">
              立即阅读 <i className="ri-arrow-right-line" />
            </span>
          </div>
        </Link>

        {/* 要闻速览 */}
        <aside className="rounded-xl border border-background-200 bg-background-50 p-5">
          <div className="flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-serif text-lg font-black text-foreground-950">
              <i className="ri-draft-line text-accent-500" /> 要闻速览
            </h3>
            <span className="flex h-5 items-center gap-0.5" aria-hidden>
              <i className="ri-record-circle-fill animate-pulse text-xs text-primary-500" />
            </span>
          </div>
          <ul className="mt-3 divide-y divide-background-200">
            {sideList.map((a) => (
              <li key={a.slug}>
                <Link
                  to={`/news/${a.slug}`}
                  className="group flex items-start gap-3 py-3.5 first:pt-1"
                >
                  <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-accent-400" aria-hidden />
                  <span>
                    <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                      {a.title}
                    </span>
                    <span className="mt-1 block text-xs text-foreground-500">{a.date}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to={`/category/${lead.category}`}
            className="mt-2 flex w-full cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-200 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览更多栏目内容 <i className="ri-arrow-right-line" />
          </Link>
        </aside>
      </div>
    </section>
  );
}